import {Component, Object3D} from '@wonderlandengine/api';
import {Cursor, CursorTarget} from '@wonderlandengine/components';
import {hapticFeedback} from '../utils/haptic-feedback.js';
import {PhongMaterial} from '../types/materials.js';
import {GA} from '../utils/ga-utils.js';

export class LevelOpeningOpenLink extends Component {
    static TypeName = 'level-opening-open-link';

    private target?: CursorTarget;
    private clicked = false;

    start() {
        this.target =
            this.object.getComponent(CursorTarget) ||
            this.object.addComponent(CursorTarget)!;
    }
    onActivate(): void {
        this.target!.onHover.add(this.onHover.bind(this));
        this.target!.onUnhover.add(this.onUnHover.bind(this));
        this.target!.onDown.add(this.onDown.bind(this));
    }
    onDeactivate(): void {
        this.target!.onHover.remove(this.onHover.bind(this));
        this.target!.onUnhover.remove(this.onUnHover.bind(this));
        this.target!.onDown.remove(this.onDown.bind(this));
    }

    onHover(_: Object3D, cursor: Cursor) {
        hapticFeedback(cursor.object, 0.5, 50);
        /* Highlight */
        this.object.parent!.getComponents('mesh').forEach((a) => {
            const material = a.material as PhongMaterial;
            material.emissiveColor = [0.12, 0.12, 0.12, 1];
        });
    }

    onUnHover(_: Object3D, cursor: Cursor) {
        hapticFeedback(cursor.object, 0.3, 50);
        /* Highlight Reset to Default */
        this.object.parent!.getComponents('mesh').forEach((a) => {
            const material = a.material as PhongMaterial;
            material.emissiveColor = [0, 0, 0, 1];
        });
    }

    onDown() {
        if (this.clicked) {
            return;
        }
        this.clicked = true;

        // make sure it only works in VR
        if (this.engine.xr) {
            GA.sendConversion('exit_to_quest_store');
            // Assume we are on Quest
            this.engine.xr.session
                .end()
                .then(() => {
                    window.open('https://vr.meta.me/s/1P3ww95tiqkt5sO', '_blank');
                })
                .catch(console.error);
        }
    }
}
